import {metrics} from '~/vendor/metrics';
import {designParamsPresent, getUpload} from './url';
import {__DEBUG__} from './env';
import rollbar from '~/vendor/rollbar';

export const normalizeTagName = tagName => {
  const normalizedTag = String(decodeURIComponent(tagName))
    .toLowerCase()
    .trim();
  return normalizedTag.replace(/%\w{2}|\W+/g, '_').replace(/(^_|_$)/g, '');
};

export const formatFontDetails = ({fontCategory, fontName}) => {
  return normalizeTagName(fontCategory) + '/' + normalizeTagName(fontName);
};

export const triggerPageViewAnalyticsTag = path => {
  if (path in pageViewPaths) {
    metrics.pageViewTag(pageViewPaths[path]);
  } else if (__DEBUG__) {
    rollbar.warning(
      `path: '${path}' has no associated page view analytics\nplease add it to pageViewPaths and/or check your spelling`
    );
    // eslint-disable-next-line no-console
    console.log(
      `path: '${path}' has no associated page view analytics\nplease add it to pageViewPaths and/or check your spelling`
    );
  }
};

export const withDesignTag = (isDirty = false) => {
  const upload = getUpload();
  if (designParamsPresent() || isDirty) {
    return 'With Design';
  } else if (upload) {
    return 'With Catalog Upload';
  } else {
    return 'Without Design';
  }
};

const analyticsTags = {
  buyClose: '/ndx/buy/close',
  quoteClose: '/ndx/quote/close',
  saveClose: '/ndx/save/close'
};

const pageViewPaths = {
  '/next': analyticsTags.buyClose,
  '/next/buy': analyticsTags.quoteClose,
  '/next/getPrice': analyticsTags.quoteClose,
  '/next/confirmIntl': analyticsTags.quoteClose,
  '/next/intlQuote': analyticsTags.quoteClose,
  '/next/quote': analyticsTags.quoteClose,
  '/next/saveForm': analyticsTags.saveClose,
  '/next/saveContinue': analyticsTags.saveClose,
  '/next/verify': analyticsTags.buyClose,
  '/next/shipping': analyticsTags.quoteClose
};

/**
 * Google Analytics v4 event tracking
 * pushes an event to the dataLayer
 * @param {Object} event - event object usually consists of
 * category, action, label
 */
export const ga4event = event => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(event);
};
